


















import Vue from "vue";
import Component from "vue-class-component";
import Tooltip from "@/shared/components/tooltip.vue";

import Filtros from "@/pages/funil/components/PesquisarLeadsFiltro.vue";
import DataTablePesquisarLead from "./components/DataTablePesquisarLead.vue";

@Component({
  components: {
    Filtros,
    Tooltip,
    DataTablePesquisarLead,
  },
})
export default class PesquisarLead extends Vue {
  voltar() {
    this.$router.back();
  }
}
